import React from "react";

export default function InscriptionSection({ whatsappQR, social }) {
  return (
    <section id="inscription" className="section inscription-dark">
      <div className="insc-glow" aria-hidden="true" />
      <div className="container">
        <div className="inscription-inner">

          <div className="inscription-text" data-reveal="left">
            <span className="section-label">📲 Rejoins la meute</span>
            <h2 className="inscription-title">Prêt à<br />commencer ?</h2>
            <p className="inscription-sub">
              Premier cours <strong>offert</strong>, sans engagement.<br />
              Dès <strong>5 ans</strong> · Tous niveaux bienvenus.
            </p>
            <div className="inscription-actions">
              <a className="btn-wh-big" href={social.wa} target="_blank" rel="noreferrer">
                <i className="fa-brands fa-whatsapp" />
                Écrire sur WhatsApp
              </a>
              <a className="btn-call-big" href="tel:+32488051685">
                <i className="fa-solid fa-phone" />
                +32 488 051 685
              </a>
            </div>

            <div className="inscription-pills">
              <span>✅ Premier cours offert</span>
              <span>✅ Sans équipement</span>
              <span>✅ Sans engagement</span>
            </div>
          </div>

          <div className="inscription-qr" data-reveal="right">
            <div className="qr-card">
              <img src={whatsappQR} alt="QR WhatsApp – Wolves Judo Bruxelles" loading="lazy" />
            </div>
            <p className="qr-label">
              <i className="fa-brands fa-whatsapp" style={{ color: "#25d366" }} />
              Scanne pour nous écrire
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
